import { type ThunkAction } from "redux-thunk";
import { type RootState } from "../store";
import { type AnyAction } from "../types";
import { externalContentActions } from "./reducer";

type ThunkResult<R> = ThunkAction<R, RootState, undefined, AnyAction>;

const externalContentPromises: Dict<Promise<string>> = {};

export function requestExternalContent(url: string): ThunkResult<Promise<string>> {
  return (dispatch, getState) => {
    const entry = getState().externalContent[url];

    if (!entry) {
      return dispatch(fetchExternalContent(url));
    }

    if (entry.data) {
      return Promise.resolve(entry.data);
    } else if (entry.state === "error") {
      return Promise.reject(new Error("error"));
    } else if (entry.state === "loading") {
      return externalContentPromises[url];
    }

    return dispatch(fetchExternalContent(url));
  };
}

function fetchExternalContent(url: string): ThunkResult<Promise<string>> {
  return (dispatch) => {
    dispatch(externalContentActions.load(url));

    return (externalContentPromises[url] = fetch(url)
      .then((res) => {
        if (res.ok) {
          return res.text();
        }
        throw res.status;
      })
      .then((content) => {
        dispatch(externalContentActions.success(url, content));
        delete externalContentPromises[url];
        return content;
      })
      .catch((err) => {
        dispatch(externalContentActions.error(url));
        delete externalContentPromises[url];
        throw err;
      }));
  };
}
